var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 18,
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M8.1 1.8a.9.9 0 0 0-.805.497L6.644 3.6H3.6a.9.9 0 0 0 0 1.8v9a1.8 1.8 0 0 0 1.8 1.8h7.2a1.8 1.8 0 0 0 1.8-1.8v-9a.9.9 0 0 0 0-1.8h-3.044l-.651-1.303A.9.9 0 0 0 9.9 1.8zM6.3 7.2a.9.9 0 0 1 1.8 0v5.4a.9.9 0 1 1-1.8 0zm4.5-.9a.9.9 0 0 0-.9.9v5.4a.9.9 0 1 0 1.8 0V7.2a.9.9 0 0 0-.9-.9z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.27f35a48993b44a9efa7f7a6ecfbaaf7.svg";
export { ForwardRef as ReactComponent };